"use client";

import type { ReactNode } from "react";
import { cn } from "../../../lib";

/** Matches learner map chrome (`TOPIC_LEARNER_NAV_CIRCLE_*` in apps/web). */
const MAP_CIRCLE_ACTION_CHROME_CLASS =
	"rounded-full bg-white shadow-lg transition-colors hover:bg-slate-50 active:bg-slate-100 dark:bg-zinc-900 dark:hover:bg-zinc-800 dark:active:bg-zinc-700 group disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-white dark:disabled:hover:bg-zinc-900";

const MAP_CIRCLE_ACTION_ICON_CLASS =
	"text-slate-600 transition-colors group-hover:text-slate-900 group-disabled:group-hover:text-slate-600 dark:text-zinc-300 dark:group-hover:text-white dark:group-disabled:group-hover:text-zinc-300";

interface HexagonMapCircleActionButtonProps {
	ariaLabel: string;
	onClick: () => void;
	disabled?: boolean;
	children: ReactNode;
}

export function HexagonMapCircleActionButton({
	ariaLabel,
	onClick,
	disabled = false,
	children,
}: HexagonMapCircleActionButtonProps) {
	return (
		<button
			type="button"
			disabled={disabled}
			onClick={onClick}
			aria-label={ariaLabel}
			className={cn(
				"inline-flex size-10 cursor-pointer items-center justify-center",
				"focus:outline-none focus:ring-2 focus:ring-black/25 focus:ring-offset-2 focus:ring-offset-background",
				"dark:focus:ring-white/50 dark:focus:ring-offset-black/30",
				MAP_CIRCLE_ACTION_CHROME_CLASS,
			)}
		>
			<span className={MAP_CIRCLE_ACTION_ICON_CLASS}>{children}</span>
		</button>
	);
}
